import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import CssBaseline from '@material-ui/core/CssBaseline';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import AddressForm from './AddressForm';
import * as routes from '../constants/routes';
import { Redirect } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import { withRouter } from 'react-router';
import ExitToApp from '@material-ui/icons/ExitToApp';
import Logo from '../assets/LIREX-logo.png';
import * as db from '../db/db';
import { AppContext } from '../context/applicationContext';

const styles = theme => ({
  appBar: {
    position: 'relative',
  },
  layout: {
    width: 'auto',
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.up(800 + theme.spacing(2*2))]: {
      width: 800,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  paper: {
    marginTop: '24px!important',
    marginBottom: theme.spacing(8),
    padding: theme.spacing(2),
    [theme.breakpoints.up(800 + theme.spacing(3*2))]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      padding: theme.spacing(3),
    },
    background: 'rgb(255 255 255 / 96%)',
  },
  stepper: {
    padding: `${theme.spacing(1) * 3}px 0 ${theme.spacing(1) * 5}px`,
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {

  },
});

const steps = ['Shipping address', 'Payment details', 'Review your order'];

function getStepContent(step) {
  switch (step) {
    case 0:
      return <AddressForm />;
    default:
      throw new Error('Unknown step');
  }
}

class HolidaysForm extends React.Component {
  static contextType = AppContext;

  constructor(props) {
    super(props);
    this.state = {
      activeStep: 0,
      holidayType: false,
      redirect: false,
      redirectToList: false
    };
  }

  componentDidMount() {
    if (this.props.route != undefined) {
      // this is used in quotes and copy-order
      this.props.router.setRouteLeaveHook(this.props.route, this.routerWillLeave);
    }
  }

  routerWillLeave(nextLocation) {
    if (true) {
      return 'You are about to leave the create order process without creating an order or quote, are you sure?';
    }
  }

  handleNext = () => {
    // this.setState(state => ({
    //   activeStep: state.activeStep + 1,
    // }));
  };

  logOut = () => {
    this.context.setStateCustom( 'userId', null);
    db.idbMethods.clear(db.userInfo);
    db.idbMethods.clear(db.holidaysForApprove);
    db.idbMethods.clear(db.holidaysForApproveList);
    db.idbMethods.clear(db.myHolidays);
    this.setState({ redirect: true });
   
  }

  handleBack = () => {
    this.setState(state => ({
      activeStep: state.activeStep - 1,
    }));
  };

  handleReset = () => {
    this.setState({
      activeStep: 0,
    });
  };
  handleTypeChange = (e) => {
    this.setState({ holidayType: e })
  }
  redirectToHolidaysList = () => {
    this.setState({ redirectToList: true });
  }

  render() {
    const { classes } = this.props;
    const { activeStep } = this.state;
    if (this.state.redirect) {
      return <Redirect to={routes.HOME_LOGIN} />
    }
    if (this.state.redirectToList) {
      return <Redirect to={routes.MY_HOLIDAYS} />
    }
    return (
      <React.Fragment>
        <CssBaseline />
        {/* <AppBar position="absolute" color="default" className={classes.appBar}>
          <Toolbar>
            <Grid container justify="flex-end" spacing={10}>
              <Grid item xs={6}>
                <Typography variant="h6" color="inherit" noWrap>
                <img className="img-logo" src={Logo}/>
            </Typography>
              </Grid>
              <Grid item align="right" xs={6}>               
                <Button
                  size="small"
                  variant="contained"
                  onClick={() => { this.logOut() }}
                  className={classes.button+' backgraound-transperent'}
                  >
                      <ExitToApp className='green-circle'></ExitToApp>
                      Изход
                    </Button>
              </Grid>
            </Grid>
          </Toolbar>
        </AppBar> */}
        <main className={classes.layout + ' header-mrg'}>
          <Paper className={classes.paper}>
          <h4 className='title-custom'>
           
              {this.state.holidayType ? 'Добавяне на болничен' : 'Добавяне на отпуск'}
            </h4>
            <React.Fragment>
              <React.Fragment>
                {/* {getStepContent(activeStep)}                   */}
                <AddressForm handleTypeChange={(e) => this.handleTypeChange(e)}  />
              </React.Fragment>

            </React.Fragment>
          </Paper>
        </main>
      </React.Fragment>
    );
  }
}

HolidaysForm.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withRouter(withStyles(styles)(HolidaysForm));